<div class="help-container">
    <img src="assets/media/images/icons/Help.svg">
    <div class="content" [innerHtml]="content"></div>
</div>